import SimpleLightbox from "simplelightbox";
import "simplelightbox/dist/simple-lightbox.min.css";

const gallery = document.querySelector(".gallery");
const loader = document.querySelector(".loader");
const loadMoreBtn = document.querySelector(".load-more");

const lightbox = new SimpleLightbox(".gallery a", {
    captionsData: "alt",
    captionDelay: 250,
});

export function createGallery(images) {
    const markup = images
        .map(({
            webformatURL,
            largeImageURL,
            tags,
            likes,
            views,
            comments,
            downloads,

        }) => `
    <li class=gallery-item>
    <a href="${largeImageURL}">
        <img src="${webformatURL}" alt="${tags}" />
    </a>
    <div class=gallery-info>
        <p><b>Likes:</b> ${likes}</p>
        <p><b>Views:</b> ${views}</p>
        <p><b>Comments:</b> ${comments}</p>
        <p><b>Downloads:</b> ${downloads}</p>
    </div>
    </li>`)
        .join("");
    
    gallery.insertAdjacentHTML("beforeend", markup);
    lightbox.refresh();
}

export function clearGallery() {
    gallery.innerHTML = "";
}

export function showLoader() {
    document.querySelector(".loader").classList.remove("is-hidden");
}

export function hideLoader() {
    document.querySelector(".loader").classList.add("is-hidden");
}

export function showLoadMoreButton() {
    loadMoreBtn.classList.remove("is-hidden");
}

export function hideLoadMoreButton() {
    loadMoreBtn.classList.add("is-hidden");
}